module.exports = __webpack_public_path__ + "img/bg5.334d2638.png";